import Api from './api';

const OuvidoriaService = {
    listar: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/restrito/ouvidoria/listar',
            params: params,
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    deletar: (id) => {
        Api.delete(`/restrito/ouvidoria/deletar/${id}`, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
    },
    ouvidEdit: async (id) => {
        const response = await Api.get(`/restrito/ouvidoria/editar/${id}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    editar: async (id, params) => {
        const response = await Api.put(`/restrito/ouvidoria/editar/${id}`,
            params,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    corrigir: async (id, params) => {
        const response = await Api({
            method: 'put',
            url: `/restrito/ouvidoria/corrigir/${id}`,
            params: params,
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    buscar: (params) => {
        const response = Api.get(`/restrito/ouvidoria/buscar?${params}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })

        return response
    }
}

export default OuvidoriaService;